"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const store_1 = require("../../context/store");
const math_1 = require("../../helpers/math");
const actions_1 = require("../../context/actions");
const styled_1 = require("./styled");
const constants_1 = require("../../data/constants");
const QrScanner_1 = __importDefault(require("../QrScanner/QrScanner"));
const Debug = () => {
    const { selectedFiat, geoCurrency, fiatValue, geoLocation, selectedCrypto, debugOptions, } = (0, store_1.useTrackedState)();
    const dispatch = (0, store_1.useDispatch)();
    const [qrOpen, setQrOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(styled_1.Wrapper, null,
        react_1.default.createElement("h3", null, "Buy Widget V2 - Debug menu"),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("h4", null, "Information"),
        react_1.default.createElement("div", null,
            "Country: ", geoLocation === null || geoLocation === void 0 ? void 0 :
            geoLocation.name,
            " ", geoLocation === null || geoLocation === void 0 ? void 0 :
            geoLocation.emoji,
            " ", geoLocation === null || geoLocation === void 0 ? void 0 :
            geoLocation.alpha2),
        react_1.default.createElement("div", null,
            "Geo Currency: ", geoCurrency === null || geoCurrency === void 0 ? void 0 :
            geoCurrency.currency),
        react_1.default.createElement("div", null,
            "Localised value:",
            (geoCurrency === null || geoCurrency === void 0 ? void 0 : geoCurrency.currency) &&
                (0, math_1.formatCurrency)(fiatValue || 0, selectedFiat || constants_1.DEFAULT_FIAT_CODE, (geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.locales[0]) || "en")),
        react_1.default.createElement("div", null,
            "Selected Crypto:",
            " ",
            react_1.default.createElement("img", { src: selectedCrypto.image, alt: selectedCrypto.code, height: 24, width: 24 }),
            " ",
            selectedCrypto.code,
            " ",
            selectedCrypto.label),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("h4", null, "Options"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("label", null,
                react_1.default.createElement("input", { type: "checkbox", checked: (debugOptions === null || debugOptions === void 0 ? void 0 : debugOptions.bypassGeoCheck) || false, onChange: () => {
                        dispatch({
                            type: actions_1.CONTEXT_ACTIONS.SET_DEBUG_OPTIONS,
                            payload: {
                                option: "bypassGeoCheck",
                                value: !(debugOptions === null || debugOptions === void 0 ? void 0 : debugOptions.bypassGeoCheck),
                            },
                        });
                    } }),
                "Bypass GEO check")),
        react_1.default.createElement("div", { style: { maxWidth: "100%" } },
            react_1.default.createElement("button", { type: "button", onClick: () => setQrOpen(true) }, "Open QR Scanner"),
            react_1.default.createElement(QrScanner_1.default, { open: qrOpen, setOpen: setQrOpen }))));
};
exports.default = Debug;
//# sourceMappingURL=Debug.js.map